import HTMLReactParser from './index.js';

export var domToReact = HTMLReactParser.domToReact;
export var htmlToDOM = HTMLReactParser.htmlToDOM;
export var attributesToProps = HTMLReactParser.attributesToProps;
export var Element = HTMLReactParser.Element;

export default HTMLReactParser;



//////////////////
// WEBPACK FOOTER
// ./node_modules/html-react-parser/index.mjs
// module id = 1217
// module chunks = 0